import firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/storage'
import { config } from 'config'

const { FIREBASE_CONFIG } = config!

firebase.initializeApp(FIREBASE_CONFIG)

const functions = firebase.app().functions('europe-west2')
// Enable the following line to use emulated cloud functions.
// functions.useEmulator('http://localhost', 5000)

export { firebase, functions }
